import React, { useState } from "react";
import WebVideoFormComponent from "./webVideoForm.component";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import { addAlert } from "modules/notification";
import { getLang } from "app/feature/constants";

const TYPES = ["new", "edit", "readonly"];

function WebVideoLinkContainer({ type, handleResult, initialValues, handleDelete, handleClose, lang, showAlert }) {

  const validateURL = (url) => {
    const urlPattern = /\.(mp4|webm|ogg)$/;
    let test1 = urlPattern.test(url);
    try {
      new URL(url);
      return test1;
    } catch (_) {
      return false;
    }
  };

  const [urls, setUrls] = useState(() => {
    let initialUrls = [];

    if (initialValues?.URL) {
      if (Array.isArray(initialValues.URL) && initialValues.URL.every(item => item.lang && "value" in item)) {
        initialUrls = lang.map(code => {
          const matchingEntry = initialValues.URL.find(entry => entry.lang === code);
          return {
            lang: code,
            value: matchingEntry ? matchingEntry.value : ""
          };
        });
      } else if (typeof initialValues.URL === "string") {
        initialUrls = lang.map(code => ({
          lang: code,
          value: code === "EN" ? initialValues.URL : ""
        }));
      }
    } else {
      initialUrls = lang.map(code => ({
        lang: code,
        value: ""
      }));
    }

    return initialUrls;
  });

  const [activeIndexTab, setActiveIndexTab] = useState(0);
  const [activeUrl, setActiveUrl] = useState(urls[activeIndexTab].value);
  const [wrongFormatLang, setWrongFormatLang] = useState([]);

  const languages = useSelector(state => state.constant.languages)

  const handleChangeActiveIndexTab = (e, index) => {
    const newUrl = { ...urls[activeIndexTab], value: activeUrl };

    if (!validateURL(activeUrl) && activeUrl !== "") {
      if (!wrongFormatLang.includes(urls[activeIndexTab].lang)) {
        setWrongFormatLang([...wrongFormatLang, urls[activeIndexTab].lang]);
      }
    } else {
      setWrongFormatLang(wrongFormatLang.filter(lang => lang !== urls[activeIndexTab].lang));
    }
    const newUrls = Array.from(urls);
    newUrls.splice(activeIndexTab, 1, newUrl);
    setUrls(newUrls);
    setActiveUrl(newUrls[index].value);
    setActiveIndexTab(index);
    
  };

  const handleSubmit = (values) => {
    const newUrl = { ...urls[activeIndexTab], value: activeUrl };
    const newUrls = Array.from(urls);
    newUrls.splice(activeIndexTab, 1, newUrl);
    setUrls(newUrls);
    setActiveUrl(newUrls[activeIndexTab].value);

    let wrongFormat = [];
    newUrls.forEach(({ lang, value }) => {
      if (!validateURL(value) && value !== "") {
        wrongFormat.push(lang);
      }
    });
    setWrongFormatLang(wrongFormat);

    if (newUrls.find(e => e.lang === "EN")?.value === "") {
      showAlert({
        severity: "error",
        message: getLang(languages,"message.error.WEB_VIDEO_NO_EN_VIDEO")
      });
      return;
    }

    if (wrongFormat.length > 0) {
      showAlert({
        severity: "error",
        message: getLang(languages, "message.error.FORM_VALIDATE_WEB_VIDEO_URL")
      });
      return;
    }
  
    handleResult({
      URL: newUrls,
      enableAutoplay: values.enableAutoplay
    });
  
  };

  return (
    <WebVideoFormComponent
      type={type}
      // handleSubmit={handleResult}
      handleSubmit={handleSubmit}
      handleDelete={handleDelete}
      initialValues={initialValues}
      lang={lang}
      languages={languages}
      handleClose={handleClose}
      activeIndexTab={activeIndexTab}
      activeUrl={activeUrl}
      handleChangeActiveIndexTab={handleChangeActiveIndexTab}
      setActiveUrl={setActiveUrl}
      wrongFormatLang={wrongFormatLang}
    />
  );
}

WebVideoLinkContainer.defaultProps = {
  type: TYPES[0],
  initialValues: { URL: "" }
};

WebVideoLinkContainer.propTypes = {
  type: PropTypes.oneOf(TYPES).isRequired,
  handleResult: PropTypes.func,
  handleDelete: PropTypes.func,
  initialValues: PropTypes.object
};
const mapDispatchToProps = dispatch => ({
  showAlert: payload => dispatch(addAlert(payload))
});

const mapStateToProps = state => ({
  lang: state.productPage.lang
});

export { TYPES };

export default connect(mapStateToProps, mapDispatchToProps)(WebVideoLinkContainer);
